export default __webpack_public_path__ + "static/media/Face.c0e78e63.svg";